import {
  ActionReducerMap,
  MetaReducer,
  createFeatureSelector
} from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

import { environment } from '../../environments/environment';

import { initStateFromLocalStorage } from './meta-reducers/init-state-from-local-storage.reducer';
import { debug } from './meta-reducers/debug.reducer';
import { RouterStateUrl } from './router/router.state';
import { settingsReducer } from './settings/settings.reducer';
import { SettingsState } from './settings/settings.model';
import { LayoutState } from '../layout/layout.state';
import { layoutReducers } from '../layout/layout.reducers';

export const reducers: ActionReducerMap<AppState> = {
  settings: settingsReducer,
  router: routerReducer,
  layout: layoutReducers
};

export const metaReducers: MetaReducer<AppState>[] = [
  initStateFromLocalStorage
];

if (!environment.production) {
  if (!environment.test) {
    metaReducers.unshift(debug);
  }
}

export const selectSettingsState = createFeatureSelector<
  AppState,
  SettingsState
>('settings');

export const selectRouterState = createFeatureSelector<
  AppState,
  RouterReducerState<RouterStateUrl>
>('router');

export const selectLayoutState = createFeatureSelector<
  AppState,
  LayoutState
>('layout');

export interface AppState {
  settings: SettingsState;
  router: RouterReducerState<RouterStateUrl>;
  layout: LayoutState;
}
